module.exports = __webpack_public_path__ + "img/buenos_aires_retiro.51a52ec9.jpg";